export function NotificationZeroStateIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
      <rect y="0.000488281" width="52" height="52" rx="8" fill="#262626" />
      <path d="M36.7654 24.3945V32.7289L26.9824 38.1823V23.5972L29.0081 27.7003L36.7654 24.3945Z" fill="white" />
      <path d="M25.8309 23.5972V38.1881L16.0479 32.7289V24.3945L23.8052 27.7003L25.8309 23.5972Z" fill="white" />
      <path d="M39.406 22.0073L29.5597 26.1978L27.2061 21.4486L37.0754 17.7412L39.406 22.0073Z" fill="white" />
      <path d="M25.6062 21.4486L23.2526 26.1978L13.4062 22.0073L15.7369 17.7412L25.6062 21.4486Z" fill="white" />
      <path d="M35.672 17.0257L26.9824 20.2908V13.813L35.672 17.0257Z" fill="white" />
      <path d="M25.8302 13.813V20.2908L17.1406 17.0257L25.8302 13.813Z" fill="white" />
    </svg>
  );
}
